import type { DateStripDay } from 'src/shared/components/ui/DateStrip';
import { addDays, formatDateKey } from 'src/shared/utils/datetime';

/**
 * The next `count` days from today as DateStrip entries, today named "Hoy". The chosen day is always included, even when it is further out, so the
 * strip never hides what is selected.
 */
export const upcomingDays = (today: string, selected: string, count = 14): DateStripDay[] => {
  const keys = Array.from({ length: count }, (_, index) => addDays(today, index));
  if (selected > keys[keys.length - 1]) keys.push(selected);
  return keys.map((key) => ({
    key,
    top: key === today ? 'Hoy' : formatDateKey(key, { weekday: 'short' }).replace('.', ''),
    main: Number(key.slice(8, 10)),
    label: formatDateKey(key, { weekday: 'long', day: 'numeric', month: 'long' }),
  }));
};
